import { bigScreen_login_children } from "dependencies/heighLevelComByLayout/login/index.js"
export default {
  name: "登录组件",
  id: "",
  type: "loginComponent",
  componentType:"emptyLayoutComponent",
  children: bigScreen_login_children,
  enable: params => params.admin
}
